import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { DrawerService } from '../../../services/drawer.service';

@Component({
  selector: 'app-main-menu-button',
  imports: [MatIconModule, MatButtonModule],
  templateUrl: './main-menu-button.html',
  styleUrl: './main-menu-button.scss',
})
export class MainMenuButton {
  constructor(private drawerService: DrawerService) {}
  toggle() {
    this.drawerService.toggleMenu();
  }
}
